import axiosInstance from 'src/utils/axios';

const BASE_URL = '/quotes/v1';

interface CreateQuoteCO2Data {
  co2Quantity: number;
  currency: string;
  merchantCode: string;
  paymentProvider: string;
  basketCode?: string;
  basket?: { portionedItems: PortionedBasketItem[] };
  programmeCode?: string;
}

interface PortionedBasketItem { 
  projectCode: string;
  co2amountKg: number;
}

async function createQuoteByCo2(data: CreateQuoteCO2Data) {
  return axiosInstance.post(`${BASE_URL}/co2?warnOnLowInventory=true`, data, {});
}

interface CreateQuoteFootprintData {
  footprintId: string;
  currency: string;
  merchantCode: string;
  paymentProvider: string;
  basketCode?: string;
}


async function createQuoteByFootprint(data: CreateQuoteFootprintData) {
  return axiosInstance.post(`${BASE_URL}/footprint?warnOnLowInventory=true`, data, {});
}

// Not used
interface CreateQuoteByProjectData {
  co2Quantity: number;
  currency: string;
  merchantCode: string;
  paymentProvider: string;
  projects: {
    projectCode: string;
  }[];
}

async function createProjectsQuoteByCo2(data: CreateQuoteByProjectData) {
  return axiosInstance.post(`${BASE_URL}/co2/projects?warnOnLowInventory=true`, data, {});
}

//

export type CreateOffsetEmissionRecord = {
  emissionRecordId: string;
  paymentProvider?: string;
  currency: string;
  basketCode: string;
  maximumFeesRatio?: number;
  basketCountry?: string;
  merchantCode: string;
  warnOnLowInventory: boolean;
} 

export const createOffsetEmissionRecord = async (payload: CreateOffsetEmissionRecord) => {
  const { warnOnLowInventory, ...data } = payload;

  return axiosInstance.post(BASE_URL + `/emission-record?warnOnLowInventory=${!!warnOnLowInventory}`, data, {});
}

export {
  createQuoteByCo2,
  createProjectsQuoteByCo2,
  createQuoteByFootprint,
};
